<template>
    <div class="Logexception">
        <div class="header">
            <el-row>
                <el-col :span="6">
                    <label class="headerlabel">提交时间</label>
                    <el-date-picker    
                    class="autowidth"
                    clearable
                    v-model="submissionTime"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">处理时间</label>
                    <el-date-picker    
                    class="autowidth"
                    clearable
                    v-model="processingTime"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">提交人</label>
                    <el-input type="text" class="autowidth" v-model="param.submitter" placeholder="请输入提交人姓名"></el-input>
                </el-col>
                
                <el-col :span="6">
                    <el-button type="primary" @click="init">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-button type="primary" style="margin-bottom: 20px;" @click="Addrecord(0)">新增记录</el-button>
            
            <el-table
            :data="LogexceptionData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;margin-bottom: 20px;">
                <el-table-column prop="requestKey" label="ID"></el-table-column>
                <el-table-column prop="eventContent" label="事件原因"></el-table-column>
                <el-table-column prop="processingResult" label="处理结果"></el-table-column>
                <el-table-column prop="submitter" label="提交人"></el-table-column>
                <el-table-column prop="submissionTime" label="提交时间"></el-table-column>
                <el-table-column prop="processingTime" label="处理时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="Edit(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageIndex"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

        <el-dialog
            title="新增记录"
            :visible.sync="dialogVisible"
            width="480px"
            center
            :before-close="handleClose">
           <div class="ruleContent">
   
            <div class="item">
                <label>事件原因</label>
                <el-input type="textarea" v-model="dialogparams.eventContent" placeholder="请输入事件原因" clearable></el-input>
            </div>
     
           </div>
            <div style="text-align: center;margin: 20px 0 10px;">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="处理结果"
            :visible.sync="EditdialogVisible"
            width="480px"
            center
            :before-close="handleClose">
           <div class="ruleContent">
   
            <div class="item">
                <label>处理结果</label>
                <el-input type="textarea" v-model="updateparams.processingResult" placeholder="请输入处理结果" clearable></el-input>
            </div>
     
           </div>
            <div style="text-align: center;margin: 20px 0 10px;">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:false,
            submissionTime:[],
            processingTime:[],
            param:{
                pageIndex:1,
                pageSize:10,
                PageTotal:0,
                startDate:'',
                endDate:'',
                pStartDate:'',
                pEndDate:'',
                submitter: ""
            },
            isEdit:false,
            dialogparams:{
                eventContent: "",//事情起因
                submitter:JSON.parse(sessionStorage.getItem('xinxi')).UserID,//活动结束时间
            },
            updateparams:{
                requestKey:'',
                processingResult:'',
                processingPersonnel:JSON.parse(sessionStorage.getItem('xinxi')).UserID
            },
            LogexceptionData:[],
            dialogVisible:false,
            EditdialogVisible:false
        }
    },
    watch:{
        submissionTime(newval,oldval){
            if(newval==null){
                this.param.startDate=''
                this.param.endDate=''
            }else{
                this.param.startDate=newval[0]
                this.param.endDate=newval[1]
            }
        },
        processingTime(newval,oldval){
            if(newval==null){
                this.param.pStartDate=''
                this.param.pEndDate=''
            }else{
                this.param.pStartDate=newval[0]
                this.param.pEndDate=newval[1]
            }
        },
    },
    mounted() {
        this.init();
    },
    methods:{
        init(){
            this.loading=true;
            this.$Http_Post('/abnormalEvents/list ',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0 || res.Code==200){
                    this.param.PageTotal=res.Counts;
                    this.LogexceptionData=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        reset(){
            this.param=this.$options.data().param;
            this.init();
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.init();
        },
        handleClose(){
            this.dialogVisible=false;
            this.EditdialogVisible=false;
        },
        Addrecord(val){
            this.dialogVisible=true;
            this.isEdit=false;
        },
        Edit(val){
            this.isEdit=true
            this.EditdialogVisible=true;
            this.updateparams.requestKey=val.requestKey;
            this.updateparams.processingResult=val.processingResult;
        },
        save(){
            if(this.isEdit){
                this.$Http_Post('/abnormalEvents/update',this.updateparams).then(res=>{
                    if(res.Code==0 || res.Code==200){
                        this.handleinitialization(1)
                        this.$message.success(res.Message);
                        this.EditdialogVisible=false;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }else{
                this.$Http_Post('/abnormalEvents/add',this.dialogparams).then(res=>{
                    if(res.Code==0 || res.Code==200){
                        this.handleinitialization(1)
                        this.$message.success(res.Message);
                        this.dialogVisible=false;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }
            
        },

    },
}
</script>
<style scoped>
.Logexception .header{background: #fff;padding:20px;}
.Logexception .headerlabel{width:90px;display: inline-block;}
.Logexception .autowidth{width: 240px;}
.Logexception .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
.Logexception .ruleContent {margin: 0 20px;}
.Logexception .ruleContent .item{padding-top: 15px;display: flex;align-items: center;}
.Logexception .ruleContent .item label{margin-right: 15px;width: 70px;display: inline-block;}
.Logexception .uploadimg{display: inline-block;}
.Logexception .upload-demo{display: inline-block;}
</style>